import qs from "qs";
import axios from "axios"

export function post(url, params) {
    return new Promise((resolve, reject) => {
        var token = localStorage.getItem("ai-token");
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
        axios.defaults.headers["Content-Type"] = "application/json";
        axios({
                url: '/api' + url,
                method: "post",
                data: JSON.stringify(params),
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                if (err.response != undefined && err.response.status == 401) {
                    location.href = '/login'
                } else { alert("接口异常"); }
                reject(err.data)
            })
    });
}
export function get(url, params) {
    return new Promise((resolve, reject) => {
        var token = localStorage.getItem("ai-token");
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
        axios.get(
                '/api' + url, params = { params }
            )
            .then(res => {
                resolve(res.data);
            })
            .catch((err) => {
                if (err.response != undefined && err.response.status == 401) {
                    location.href = '/login'
                } else { alert("接口异常"); }
                reject(err.data);
            })
    });
}

export function download(url, name) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            responseType: 'blob'
        }).then((res) => {
            debugger;
            if ('download' in document.createElement('a')) {
                let url = window.URL.createObjectURL(res.data);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } else {
                navigator.msSaveBlob(res.data, name)
            }
            // window.close();
            resolve("ok");
        }).catch(err => {
            reject(err.data);
        })
    })
}



export default {get, post, download }